export default __webpack_public_path__ + "static/media/emptyViewFolder.d2cb0aa8.svg";